import { createSelector } from '@reduxjs/toolkit';
import { FDealType, FOfferType } from '../../../../packages/JsonQuery';
import { selectDealType, selectOfferType } from 'shared/selectors/jsonQuery';

export const selectPriceTypeAvailable = createSelector(
  [selectDealType, selectOfferType],
  (dealType, offerType) => dealType === FDealType.Sale && (offerType & FOfferType.Urban) !== 0,
);
